// // assets/inline-search-bar.js

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('[data-predictive-search]').forEach((wrap) => {
//     const input = wrap.querySelector('[data-predictive-search-input]');
//     const resultsBox = wrap.querySelector('[data-predictive-search-results]');

//     if (!input || !resultsBox) return;

//     let debounceTimer;

//     const hideResults = () => {
//       resultsBox.hidden = true;
//     };

//     const showResults = () => {
//       resultsBox.hidden = false;
//     };

//     const escapeHTML = (value) => {
//       const div = document.createElement('div');
//       div.textContent = value || '';
//       return div.innerHTML;
//     };

//     const searchProducts = async (term) => {
//       try {
//         const root = window.Shopify.routes.root || '/';

//         const url =
//           `${root}search/suggest.json` +
//           `?q=${encodeURIComponent(term)}` +
//           `&resources[type]=product` +
//           `&resources[limit]=10` +
//           `&resources[options][unavailable_products]=last` +
//           `&resources[options][fields]=title,product_type,variants.title,vendor`;

//         const response = await fetch(url, {
//           method: 'GET',
//           headers: {
//             Accept: 'application/json'
//           }
//         });

//         if (!response.ok) {
//           throw new Error(`Search request failed: ${response.status}`);
//         }

//         const data = await response.json();

//         const products =
//           data?.resources?.results?.products || [];

//         resultsBox.innerHTML = '';

//         if (!products.length) {
//           resultsBox.innerHTML = `
//             <div class="inline-search-bar__no-results">
//               No products found
//             </div>
//           `;

//           showResults();
//           return;
//         }

//         products.forEach((product) => {
//           const a = document.createElement('a');

//           a.href = product.url;
//           a.className = 'inline-search-bar__result';

//           const image =
//             product.featured_image?.url ||
//             product.image ||
//             '';

//           const title =
//             escapeHTML(product.title);

//           const price =
//             escapeHTML(product.price);

//           a.innerHTML = `
//             ${
//               image
//                 ? `
//                   <img
//                     src="${image}"
//                     alt="${title}"
//                     loading="lazy"
//                     width="44"
//                     height="44"
//                   >
//                 `
//                 : `
//                   <span class="inline-search-bar__result-placeholder"></span>
//                 `
//             }

//             <span class="inline-search-bar__result-content">
//               <span class="inline-search-bar__result-title">
//                 ${title}
//               </span>

//               ${
//                 price
//                   ? `
//                     <span class="inline-search-bar__result-price">
//                       ${price}
//                     </span>
//                   `
//                   : ''
//               }
//             </span>
//           `;

//           resultsBox.appendChild(a);
//         });

//         showResults();

//       } catch (error) {
//         console.error('Predictive search error:', error);

//         resultsBox.innerHTML = `
//           <div class="inline-search-bar__no-results">
//             Unable to load products
//           </div>
//         `;

//         showResults();
//       }
//     };

//     input.addEventListener('input', () => {
//       clearTimeout(debounceTimer);

//       const term = input.value.trim();

//       if (term.length < 2) {
//         resultsBox.innerHTML = '';
//         hideResults();
//         return;
//       }

//       debounceTimer = setTimeout(() => {
//         searchProducts(term);
//       }, 300);
//     });

//     input.addEventListener('keydown', (event) => {
//       if (event.key === 'Escape') {
//         hideResults();
//       }
//     });

//     document.addEventListener('click', (event) => {
//       if (!wrap.contains(event.target)) {
//         hideResults();
//       }
//     });
//   });
// });

// assets/inline-search-bar.js

/**
 * Predictive dropdown disabled.
 * The normal search form, Enter key and search icon continue to work.
 */
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-predictive-search-results]')
    .forEach((resultsBox) => {
      resultsBox.remove();
    });
});